import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Button } from '@app/shared/ui/button/button';

@Component({
  imports: [TranslocoDirective, Button],
  selector: 'app-home-hero',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './hero.html',
})
export class Hero {
  readonly ctaClick = output<void>();
}
